"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const useAddSurvicateUserInfo_1 = require("hooks/useAddSurvicateUserInfo");
const withAddSurvicateUserInfo = (Component) => {
    return (props) => {
        (0, useAddSurvicateUserInfo_1.useAddSurvicateUserInfo)();
        return (0, jsx_runtime_1.jsx)(Component, { ...props });
    };
};
exports.default = withAddSurvicateUserInfo;
